import PartnerPaymentMethod from './PartnerPaymentMethodContainer';
import PartnerPaymentMethodSelection from './PartnerPaymentMethodSelectionContainer';

export { PartnerPaymentMethodSelection };
export default PartnerPaymentMethod;
